$(document).ready(function(){
  const redirects = [
    'vitaminpulver-1',
    'mylky-messloffel-set-1',
    'mylky-kaffeetasse-1',
    'mylky-flaschen-burste-1',
    'your-tree-in-the-mylky-forest',    
    'mylky-flaschen-burste-2'
  ];

  const currentPath = window.location.pathname; // only the URL path

  for (const slug of redirects) {
    if (currentPath.includes(slug)) {
      window.location.replace('/products/mylky');
      break; // stop after first match
    }
  }
  
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has('add_to_cart') && urlParams.get('add_to_cart') === 'true') {
    setTimeout(() => {
      $('.product__info-wrapper .form button.main-button').click();
    }, 500); // Short delay for page load
  }

  $('.pdp-sticky-atc').on('click', function(){
    $('.product__info-wrapper .form button.main-button').click();
  })

  // Open your detail by default
  $('.menu-drawer-product-list-wrapper').attr('open', false);

  // Initialize states on page load
  $('.menu-drawer-product-list-wrapper summary').each(function () {
    let summary = $(this);
    let details = summary.parent('.menu-drawer-product-list-wrapper');
    let icon = summary.find('.menu-drawer-product-list-icon');

    summary.attr('aria-expanded', details.is('[open]'));
    icon.toggleClass('rotate-180', details.is('[open]'));
  });

  // Keep aria-expanded + rotate class in sync
  $('.menu-drawer-product-list-wrapper').on('toggle', function () {
    let details = $(this);
    let summary = details.children('.menu-drawer-product-list-wrapper summary');
    let icon = details.find('.menu-drawer-product-list-icon');

    summary.attr('aria-expanded', details.is('[open]'));
    icon.toggleClass('rotate-180', details.is('[open]'));
  });

  $('.close-localization').on('click touchstart', function(e) {

    e.preventDefault();  // prevent default link/button behavior
    e.stopPropagation(); // stop click from triggering elements behind it
    const disclosure = $(this).closest('.disclosure');
    const wrapper = disclosure.find('.disclosure__list-wrapper');

    // Remove hidden
    wrapper.removeAttr('hidden');

    // Close the details element properly
    disclosure.find('.disclosure__button').attr('aria-expanded', 'false');
    disclosure.find('.disclosure__list-wrapper').prop('hidden', true); // hide again
  });

  var productSwiper = new Swiper('.product-usage-steps-wrapper', {
    loop: false,
    spaceBetween: 20,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    on: {
      init: function() {
        setActiveSteps(0); // default first step
      },
      slideChange: function() {
        setActiveSteps(this.activeIndex);
      },
    },
  });

  // Function to update steps progressively
  function setActiveSteps(index) {
    $('.product-usage-points-box').removeClass('active');
    $('.product-usage-points-box').each(function(i) {
      if (i <= index) {
        $(this).addClass('active');
      }
    });
  }

  // Clicking step should also sync with slider
  $('.product-usage-points-box').on('click', function() {
    var stepIndex = $(this).index();
    productSwiper.slideTo(stepIndex);
    setActiveSteps(stepIndex);
  });

  (function () {
    const DESKTOP_BREAKPOINT = 767;

    // Remove upsell
    $(document).on('click.upsell', '.product_bundle_container .remove_upsell', function (e) {
      e.preventDefault();
      e.stopPropagation();

      const container = $(this).closest('.product_bundle_container');
      $(this).removeClass('upsell-selected');

      container.find('.upsell-appended').addClass('remove_upsell_product');
      container.find('.upsell_checkbox').removeClass('upsell_checked');
      container.find('.mobile_upsell_checkbox.upsell_checkbox').removeClass('upsell_checked');
      container.find('.upsell-atc').addClass('upsell-atc-hidden');
    });

    // Toggle upsell (desktop only)
    $(document).on('click.upsell', '.product_bundle_upsell_wrapper', function () {
      const container = $(this).closest('.product_bundle_container');
      if (window.innerWidth >= DESKTOP_BREAKPOINT) {  
        $(this).toggleClass('upsell-selected');
        container.find('.upsell_checkbox').toggleClass('upsell_checked');
        container.find('.upsell-appended').toggleClass('remove_upsell_product');
        container.find('.upsell-atc').toggleClass('upsell-atc-hidden');
      }
      else {
        $(this).toggleClass('upsell-selected');
        container.find('.upsell_checkbox').toggleClass('upsell_checked');
        container.find('.upsell-appended').toggleClass('remove_upsell_product');
        container.find('.upsell-atc').toggleClass('upsell-atc-hidden');
      }
    });

    // $(document).on('click', '.upsell-atc button[type="button"]', function (e) {
    //   e.preventDefault();
    //   e.stopImmediatePropagation();

    //   const button = $(this);
    //   const form = $(this).closest('form');
    //   const container = button.closest('.product_bundle_container');

    //   // ✅ CHECK: upsell must be enabled
    //   const isUpsellChecked = container.find('.upsell_checkbox').hasClass('upsell_checked');

    //   if (!isUpsellChecked) {
    //     console.log('Upsell not selected — skipping upsell add');
    //     return;
    //   }

    //   // 🔹 Upsell variant
    //   const upsellVariantId = form.find('input[name="id"]').val();
    //   if (!upsellVariantId) {
    //     console.error('Upsell variant missing');
    //     return;
    //   }

    //   // 🔹 Main product form
    //   const mainForm = $('.product__info-wrapper form[data-type="add-to-cart-form"]');
    //   if (!mainForm.length) {
    //     console.error('Main product form not found');
    //     return;
    //   }

    //   const mainVariantId = mainForm.find('input[name="id"]').val();
    //   const mainQty = parseInt(mainForm.find('input[name="quantity"]').val(), 10) || 1;

    //   // 🔹 Payload: add BOTH items together
    //   const payload = {
    //     items: [
    //       {
    //         id: mainVariantId,
    //         quantity: mainQty
    //       },
    //       {
    //         id: upsellVariantId,
    //         quantity: 1,
    //         properties :{"_Gf_pdp":"mylky_gift"}
    //       }
    //     ]
    //   };

    //   // 🔹 UI loading state
    //   $(button).addClass('loading').attr('aria-disabled', 'true');

    //   $.ajax({
    //     url: '/cart/add.js',
    //     type: 'POST',
    //     dataType: 'json',
    //     contentType: 'application/json',
    //     data: JSON.stringify(payload),
    //     success: function (response) {
    //       const cart =
    //         document.querySelector('cart-notification') ||
    //         document.querySelector('cart-drawer');

    //       if (cart && typeof cart.renderContents === 'function') {
    //         cart.renderContents(response);
    //       }

    //       // Optional custom event
    //       document.dispatchEvent(
    //         new CustomEvent('cart:refresh', { detail: response })
    //       );
    //     },
    //     error: function (xhr) {
    //       console.error('Add to cart failed', xhr.responseJSON || xhr.responseText);
    //     },
    //     complete: function () {
    //       $(button).removeClass('loading').removeAttr('aria-disabled');
    //     }
    //   });
    // });

    // // 🔒 Block native theme ATC completely

    // // $('.product-form .main-button[type="submit"]').attr('type', 'button');
    // $(document).on('submit', 'form[data-type="add-to-cart-form"]', function (e) {
    //   e.preventDefault();
    //   e.stopImmediatePropagation();
    //   console.log("-----------------------------------------------")
    //   return false;
    // });
    // $(document).on('click', '.product-form button[type="submit"]', function (e) {
    //     e.preventDefault();
    //     e.stopImmediatePropagation();
    //     console.log("lllllllllllllllllllllllllllllllllllllllllllllllllllll")
    //     return false;
    //   }
    // );

    // function triggerUpsellATC() {
    //   const upsellBtn = document.querySelector('.upsell-atc button[type="button"]');

    //   if (upsellBtn) {
    //     upsellBtn.click(); // ✅ single source of truth
    //   } else {
    //     console.warn('Upsell ATC button not found');
    //   }
    // }

    // $(document).on('click', '.product-form button[type="submit"]', function (e) {
    //   e.preventDefault();
    //   e.stopImmediatePropagation();
    //   triggerUpsellATC();
    // });

    $(document).on('click', '.upsell-atc button[type="button"]', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      const button = $(this);
      const container = button.closest('.product_bundle_container');

      // 🔹 Main product form
      const mainForm = $('.product__info-wrapper form[data-type="add-to-cart-form"]');
      if (!mainForm.length) {
        console.error('Main product form not found');
        return;
      }

      const mainVariantId = mainForm.find('input[name="id"]').val();
      const mainQty = parseInt(mainForm.find('input[name="quantity"]').val(), 10) || 1;

      if (!mainVariantId) {
        console.error('Main variant missing');
        return;
      }

      // 🔹 Check upsell state
      const isUpsellChecked = container.find('.upsell_checkbox').hasClass('upsell_checked');

      // 🔹 Base payload (always add main product)
      const payload = {
        items: [
          {
            id: mainVariantId,
            quantity: mainQty
          }
        ]
      };

      // 🔹 If upsell selected → add upsell item
      if (isUpsellChecked) {
        const upsellVariantId = container
          .find('form input[name="id"]')
          .val();

        if (upsellVariantId) {
          payload.items.push({
            id: upsellVariantId,
            quantity: 1,
            properties: { _Gf_pdp: 'mylky_gift' }
          });
        }
      }

      // 🔹 UI loading state
      button.addClass('loading').attr('aria-disabled', 'true');

      $.ajax({
        url: '/cart/add.js',
        type: 'POST',
        dataType: 'json',
        contentType: 'application/json',
        data: JSON.stringify(payload),
        success: function (response) {
          const cart =
            document.querySelector('cart-notification') ||
            document.querySelector('cart-drawer');

          if (cart && typeof cart.renderContents === 'function') {
            cart.renderContents(response);
          }

          document.dispatchEvent(
            new CustomEvent('cart:refresh', { detail: response })
          );
        },
        error: function (xhr) {
          console.error('Add to cart failed', xhr.responseJSON || xhr.responseText);
        },
        complete: function () {
          button.removeClass('loading').removeAttr('aria-disabled');
        }
      });
    });

  })();

  // Discounted Badge Text
  // function addDiscountBadgeToCartItem() {
  //   const targetVariantId = '44449800618054';

  //   $('.qsc2-product-item__product-title').each(function () {
  //     const title = $(this);
  //     const link = title.find('a');

  //     if (!link.length) return;

  //     const href = link.attr('href');

  //     let discountText = 'Save €5'; // fallback

  //     if (window.location.hostname.includes('.com.au')) {
  //       discountText = 'Save $5';
  //     } else if (window.location.hostname.includes('.ch')) {
  //       discountText = 'Save CHF 5';
  //     }

  //     if (href && href.includes(`variant=${targetVariantId}`)) {
  //       if (!title.find('.discount-drawer-badge').length) {
  //         title.append(
  //           `<span class="discount-drawer-badge"> - (${discountText})</span>`
  //         );
  //       }
  //     }
  //   });
  // }

  // (function observeCartChanges() {
  //   const observer = new MutationObserver(() => {
  //     // Run only if cart items exist
  //     if (document.querySelector('.qsc2-product-item__product-title')) {
  //       addDiscountBadgeToCartItem();
  //     }
  //   });

  //   observer.observe(document.body, {
  //     childList: true,
  //     subtree: true
  //   });
  // })();
});

// green friday------------------------------------------------------------------------------------------
// const activeProductId = "44038160810054"; //44038160810054   44038165692486

// const allOptions = document.querySelectorAll(
//   ".gf-product-image, .gf-extra-product-container"
// );

// const allHeadings = document.querySelectorAll(".gf-pdp-heading-value");

// // 🔹 Function to show only matching heading
// function showMatchingHeading(productId) {
//   allHeadings.forEach((p) => {
//     if (p.getAttribute("data-producttitle") === productId) {
//       p.style.display = "block";
//     } else {
//       p.style.display = "none";
//     }
//   });
// }

// // 🔹 Initialize active image + heading
// allOptions.forEach((el) => {
//   if (el.getAttribute("data-productid") === activeProductId) {
//     el.classList.add("gf-pdp-active");
//     showMatchingHeading(activeProductId);
//   } else {
//     el.classList.remove("gf-pdp-active");
//   }
// });

// // 🔹 Click to toggle active state and show related heading
// allOptions.forEach((el) => {
//   el.addEventListener("click", () => {
//     allOptions.forEach((i) => i.classList.remove("gf-pdp-active"));
//     el.classList.add("gf-pdp-active");

//     const productId = el.getAttribute("data-productid");
//     showMatchingHeading(productId);
//   });
// });

// const gc_originalFetch = window.fetch;
const gc_originalSend = XMLHttpRequest.prototype.send;
// let gc_cartData;
// let old_quantity;
// let new_quantity;
// // let mylkyMainPro = "42571798839366" //dummy product
// let mylkyMainPro = "42571798609990"

// async function gcGetCartData() {
//   const res = await fetch("/cart.json", {
//     headers: { "x-bypass-intercept": "1" }
//   });
//   gc_cartData = await res.json();
//   return gc_cartData;
// }

// async function getExistingProductQty(variantId) {
//   const res = await fetch('/cart.js');
//   const cart = await res.json();
//   const item = cart.items.find(i => (String(i?.variant_id)) === String(variantId));
//   return item ? item.quantity : 0;
// }

// document.addEventListener('DOMContentLoaded', async () => {
//   const variantId = mylkyMainPro; // Replace with real variant ID
//   const qty = await getExistingProductQty(variantId);
//   old_quantity = qty;
// });

// async function sectionRender() {
//   //  try {
//   //       document.dispatchEvent(new CustomEvent("cart:change"));
//   //     } catch (error) {
//   //       console.log(error,"---error");
//   //     }

//   const cartDrawer = document.querySelector('cart-drawer');
//   if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
//     const sections = cartDrawer.getSectionsToRender().map(s => s.section);
//     const res = await fetch(`/cart?sections=${sections.join(',')}`);
//     const parsed = await res.json();
//     cartDrawer.renderContents({ sections: parsed });
//   }
// }

// async function greenFriday() {
//   await gcGetCartData();
//   let mainProduct = gc_cartData?.items?.find((cartItem) => {
//     return String(cartItem?.variant_id) === mylkyMainPro;
//   });
//   new_quantity = mainProduct?.quantity

//   if (mainProduct) {
//     await greenFridayAddToCart(mainProduct?.quantity);
//   } else {
//     await greenFridayUpdateToCart();
//   }
// }

// function getLocalStorage() {
//   let cart = localStorage.getItem('gf_cart');
//   return cart ? JSON.parse(cart) : [];
// }

// // Save cart to localStorage
// function saveLocalStorage(cart, quantity = 1) {
//   // localStorage.setItem('gf_cart', JSON.stringify(cart));
//   for (let i = 0; i < quantity; i++) {
//     localStorage.setItem('gf_cart', JSON.stringify(cart));
//   }
// }

// function getVariantCount(variantId) {
//   const cart = getLocalStorage();
//   let count = 0;

//   for (const item of cart) {
//     if (parseInt(item) === parseInt(variantId)) {
//       // If you store quantity, add that instead of 1
//       count += item.quantity || 1;
//     }
//   }

//   return count;
// }


// // Remove entire cart
// function removeLocalStorage() {
//   localStorage.removeItem('gf_cart');
// }

// // Add a variant ID to cart
// // function addToLocalStorage(variantId) {
// //   let cart = getLocalStorage();
// //   let proVariantId = parseInt(variantId)
// //   cart.push(proVariantId);
// //   saveLocalStorage(cart);
// // }

// function addToCart(productId, quantity = 1) {
//   let cart = getLocalStorage();

//   // Add productId multiple times based on quantity
//   for (let i = 0; i < quantity; i++) {
//     cart.push(parseInt(productId));
//   }

//   saveLocalStorage(cart);
// }

// function removeFromLocalStorage(variantId, quantity = 1) {
//   let cart = getLocalStorage();
//   const idToRemove = parseInt(variantId);

//   for (let i = 0; i < quantity; i++) {
//     const index = cart.lastIndexOf(idToRemove);
//     if (index !== -1) {
//       cart.splice(index, 1);
//     } else {
//       break;
//     }
//   }
//   saveLocalStorage(cart);
// }

// function getLastVariant() {
//   let cart = localStorage.getItem('gf_cart');
//   if (!cart) return null;
//   cart = JSON.parse(cart);
//   if (cart.length === 0) return null;
//   return cart[cart.length - 1];
// }

// async function greenFridayUpdateToCart(quantity) {
//   const activeProduct = document.querySelector('.green-friday-product-wrapper .gf-pdp-active');
//   const productId = activeProduct.getAttribute('data-productid');
//   const giftVariantId = "44038167756870";
//   const selectedProductId = parseInt(productId);
//   let diff_quantity = Math.abs(new_quantity - old_quantity);

//   let mylkyMainProData = gc_cartData?.items?.find((cartItem) => {
//     return (
//       String(cartItem?.variant_id) === mylkyMainPro
//     );
//   })

//   let mylkyProQuantity = mylkyMainProData?.quantity;
//   // Filter the cart for both — returns an array of matches
//   let giftProduct
//    = gc_cartData?.items?.filter((cartItem) => {
//     return (
//       cartItem.properties._Gf_pdp === "giftItem" || cartItem.properties._Gf_Tree_pdp === "giftItem"
//     );
//   });

//   let treeGiftPro = gc_cartData?.items?.find((cartItem) => {
//     return (
//       String(cartItem.variant_id) === "44038167756870" && cartItem.properties._Gf_pdp === "giftItem"
//     );
//   });

//   let freeGiftPro = gc_cartData?.items?.find((cartItem) => {
//     return (
//       String(cartItem.variant_id) === productId &&
//       cartItem.properties._Gf_pdp === "giftItem"
//     );
//   });

//   if (!quantity) {
//     const updates = {};

//     giftProduct.forEach((cartItem) => {
//       updates[cartItem.key] = 0;
//     });

//     const response = await fetch("/cart/update.js?_gf_pdp", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         Accept: "application/json",
//       },
//       body: JSON.stringify({ updates }),
//     });

//     const result = await response.json();

//     if (!response.ok) {
//       console.error("🚫 Error:", result);
//       throw new Error(`Add to cart failed: ${response.status}`);
//     }

//     removeLocalStorage();
//     await sectionRender();
//   } else {
//     if (old_quantity < new_quantity) {
//       let updates = {}
//       let mylkyGiftPro = gc_cartData?.items?.filter((cartItem) => cartItem.properties._Gf_pdp);
//       let totalMylkyGiftQuantity = mylkyGiftPro.reduce(
//         (total, item) => total + (item.quantity || 0),
//         0
//       );

//       let mylkyTreePro = gc_cartData?.items?.find((cartItem) => cartItem.properties._Gf_Tree_pdp);
//       let totalMylkyTreeQuantity = mylkyTreePro?.quantity

//       let freeTreeQuantity = mylkyProQuantity - totalMylkyTreeQuantity
//       let freeGiftQuantity = mylkyProQuantity - totalMylkyGiftQuantity

//       console.log(freeGiftQuantity, "freeGiftQuantity", freeGiftPro?.quantity, treeGiftPro?.quantity, "freeTreeQuantity", treeGiftPro?.quantity);
//       console.log(freeGiftPro, "freeGiftPro")
//       if (freeGiftPro) {
//         // [freeGiftPro?.key]: (freeGiftPro?.quantity || 0) + freeGiftQuantity,
//         if(String(freeGiftPro?.variant_id) ===  "44038167756870"){
//           updates = {
//               [freeGiftPro?.key]: (freeGiftPro?.quantity || 0) + (diff_quantity*2),
//             };
//         }else{
//           if (treeGiftPro) {
//           updates = {
//             [treeGiftPro?.key]: (treeGiftPro?.quantity || 0) + diff_quantity,
//             [freeGiftPro?.key]: (freeGiftPro?.quantity || 0) + diff_quantity,
//           };
//         } else {
//           updates = {
//             [freeGiftPro?.key]: (freeGiftPro?.quantity || 0) + diff_quantity,
//           };
//         }
//         }
//       }

//       console.log(updates, "updates from one");
//       const response = await fetch("/cart/update.js?_gf_pdp", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Accept: "application/json",
//         },
//         body: JSON.stringify({ updates }),
//       });

//       const result = await response.json();
//       if (!response.ok) {
//         console.error("🚫 Error:", result);
//         throw new Error(`Add to cart failed: ${response.status}`);
//       }
//       addToCart(productId, diff_quantity);
//       old_quantity = quantity;
//       await sectionRender();
//     } else {
//       let lastVariant = getLastVariant();
//       let lastProVariant = gc_cartData?.items?.find((cartItem) => {
//         return (
//           String(cartItem.variant_id) === String(lastVariant) &&
//           cartItem.properties._Gf_pdp === "giftItem"
//         );
//       });

//       let mylkyGiftPro = gc_cartData?.items?.filter((cartItem) => cartItem.properties._Gf_pdp);
//       let totalMylkyGiftQuantity = mylkyGiftPro.reduce(
//         (total, item) => total + (item.quantity || 0),
//         0
//       );
//       let updates = {};
//       let mylkyTreePro = gc_cartData?.items?.find((cartItem) => cartItem.properties._Gf_Tree_pdp);
//       let totalMylkyTreeQuantity = mylkyTreePro?.quantity;
//       let freeTreeQuantity = Math.abs(mylkyProQuantity - totalMylkyTreeQuantity)

//       if (totalMylkyGiftQuantity > mylkyProQuantity) {
//         // if (treeGiftPro) {
//         //   console.log("-------1");
//         //   updates = {
//         //     [treeGiftPro?.key]: (treeGiftPro?.quantity || 0) - diff_quantity,
//         //   };
//         // }
//         if (lastProVariant) {
//             if(String(lastProVariant?.variant_id) ===  "44038167756870"){
//             updates = {
//                 [lastProVariant?.key]: (lastProVariant?.quantity || 0) - (diff_quantity * 2),
//               };
//                removeFromLocalStorage(lastProVariant?.variant_id,diff_quantity)
//             } else if (treeGiftPro) {
//             updates = {
//               [treeGiftPro?.key]: (treeGiftPro?.quantity || 0) - diff_quantity,
//               [lastProVariant?.key]: (lastProVariant?.quantity || 0) - diff_quantity,
//             };
//             removeFromLocalStorage(lastProVariant?.variant_id,diff_quantity)
//           } else {
//             updates = {
//               [lastProVariant?.key]: (lastProVariant?.quantity || 0) - diff_quantity,
//             };
//             removeFromLocalStorage(lastProVariant?.variant_id,diff_quantity)
//           }
//         } else {
//           if (treeGiftPro) {
//             updates = {
//               [treeGiftPro?.key]: (treeGiftPro?.quantity || 0) - diff_quantity,
//             };
//           }
//         }
//       } else  {
//         if (treeGiftPro) {
//           updates = {
//             [treeGiftPro?.key]: (treeGiftPro?.quantity || 0) - diff_quantity,
//           };
//         }
//       }
//       console.log(updates, "updates from two");

//       const response = await fetch("/cart/update.js?_gf_pdp", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Accept: "application/json",
//         },
//         body: JSON.stringify({ updates }),
//       });

//       const result = await response.json();
//       if (!response.ok) {
//         console.error("🚫 Error:", result);
//         throw new Error(`Add to cart failed: ${response.status}`);
//       }
//       old_quantity = quantity;
//       await sectionRender();
//     }
//   }
// }

// async function greenFridayAddToCart(quantity) {
//   try {
//     const activeProduct = document.querySelector('.green-friday-product-wrapper .gf-pdp-active');
//     const productId = activeProduct.getAttribute('data-productid');
//     const giftVariantId = "44038167756870";
//     const selectedProductId = parseInt(productId);
//     let diff_quantity = Math.abs(new_quantity - old_quantity);
//     // let giftProduct = gc_cartData?.items?.filter((cartItem) => {
//     //   return (
//     //     String(cartItem?.variant_id) === giftVariantId
//     //     || parseInt(cartItem?.variant_id) === selectedProductId
//     //   );
//     // })  || [];

//       let giftProduct = gc_cartData?.items?.filter((cartItem) => {
//       return (
//        cartItem.properties._Gf_pdp
//       );
//     }) || [];

//     let selectedProduct = gc_cartData?.items?.filter((cartItem) => {
//       return (
//         parseInt(cartItem?.variant_id) === selectedProductId && cartItem.properties._Gf_pdp === "giftItem"
//       );
//     }) || [];

//     if (giftProduct.length <= 0) {
//       const itemsToAdd = [
//         // {
//         //   id: parseInt(productId),
//         //   quantity: 1,
//         //   properties: {
//         //     _Gf_pdp: "giftItem"
//         //   }
//         // },
//         {
//           id: 44038167756870,
//           quantity: 1,
//           properties: {
//             _Gf_pdp: "giftItem"
//           }
//         }
//       ];
//       const response = await fetch("/cart/add.js?_gf_pdp", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Accept: "application/json",
//         },
//         body: JSON.stringify({ items: itemsToAdd }),
//       });

//       const result = await response.json();
//       console.log(productId, "productId")
//       addToCart(productId);
//       old_quantity = quantity
//       if (!response.ok) {
//         console.error("🚫 Error:", result);
//         throw new Error(`Add to cart failed: ${response.status}`);
//       }

//        const treeItem = [
//         {
//             id: parseInt(productId),
//           quantity: 1,
//           properties: {
//             _Gf_pdp: "giftItem"
//           }
//         }
//       ];
//       const treeResponse = await fetch("/cart/add.js?_gf_pdp", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Accept: "application/json",
//         },
//         body: JSON.stringify({ items: treeItem }),
//       });

//       const treeResult = await treeResponse.json();
//       await sectionRender()
//     } else if (selectedProduct?.length <= 0 && old_quantity < new_quantity) {

//       let diff_quantity = new_quantity - old_quantity
//       const itemsToAdd = [
//         // {
//         //   id: parseInt(productId),
//         //   quantity: diff_quantity,
//         //   properties: {
//         //     _Gf_pdp: "giftItem"
//         //   }
//         // }
//         {
//           id: 44038167756870,
//           quantity: diff_quantity,
//           properties: {
//             _Gf_pdp: "giftItem"
//           }
//         }
//       ];
//       const response = await fetch("/cart/add.js?_gf_pdp", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Accept: "application/json",
//         },
//         body: JSON.stringify({ items: itemsToAdd }),
//       });

//       const result = await response.json();
//       console.log(productId, "productId2")
//       console.log(diff_quantity, "diff_quantity")
//       addToCart(productId, diff_quantity);

//       old_quantity = quantity
//       if (!response.ok) {
//         console.error("🚫 Error:", result);
//         throw new Error(`Add to cart failed: ${response.status}`);
//       }
      
//       const treeItem = [
//          {
//           id: parseInt(productId),
//           quantity: diff_quantity,
//           properties: {
//             _Gf_pdp: "giftItem"
//           }
//         }
//       ];
//       const treeResponse = await fetch("/cart/add.js?_gf_pdp", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Accept: "application/json",
//         },
//         body: JSON.stringify({ items: treeItem }),
//       });

//       const treeResult = await treeResponse.json();
      
//       await sectionRender()
//     } else {
//       await greenFridayUpdateToCart(quantity)
//     }
//   } catch (error) {
//     console.error("❌ Error adding to cart:", error);
//   }
// }

// const gcCartApi = [
//   { label: "add", url: "/cart/add.js" },
//   { label: "add", url: "/cart/add" },
//   { label: "change", url: "/cart/change.js" },
//   { label: "change", url: "/cart/change" },
//   { label: "update", url: "/cart/update.js" },
//   { label: "update", url: "/cart/update" },
//   { label: "clear", url: "/cart/clear.js" },
//   { label: "clear", url: "/cart/clear" },
// ];

// document.addEventListener('cart:changed', async () => {
//   await gcGetCartData();
//   await greenFriday();
// });

// window.fetch = async function (input, init = {}) {
//   const url = typeof input === 'string'
//     ? input
//     : (input && typeof input.url === 'string' ? input.url : undefined);

//   if (typeof url !== 'string') {
//     const response = await gc_originalFetch(input, init);
//     return response;
//   }

//   if (url.includes('_gf_pdp')) {
//     return await gc_originalFetch(input, init);
//   }

//   const isCartMutation = gcCartApi.some(route => {
//     const base = route.url.replace(".js", "");
//     return (
//       (url.includes(base) || url.includes(base + ".js"))
//     );
//   });

//   const body = init.body || null;
//   let line, quantity;
//   let parsedBody;

//   try {
//     parsedBody = (typeof body === "string" && body.startsWith("{"))
//       ? JSON.parse(body)
//       : body;
//   } catch {
//     parsedBody = body;
//   }

//   if (parsedBody instanceof URLSearchParams || typeof parsedBody === "string") {
//     const params = new URLSearchParams(
//       typeof parsedBody === "string" ? parsedBody : parsedBody.toString()
//     );
//     line = parseInt(params.get("line"), 10);
//     quantity = parseInt(params.get("quantity"), 10);
//   } else if (typeof parsedBody === "object" && parsedBody !== null) {
//     line = parseInt(parsedBody.line, 10);
//     quantity = parseInt(parsedBody.quantity, 10);
//   }

//   const response = await gc_originalFetch(input, init);
//   if (isCartMutation && response.ok) {
//     setTimeout(async () => {
//       document.dispatchEvent(new CustomEvent('cart:changed'));
//     }, 200);
//   }
//   return response;
// };

// const originalXhrSend = XMLHttpRequest.prototype.send;
// XMLHttpRequest.prototype.send = async function (body) {
//   const xhr = this;
//   const url = xhr._url || xhr?.__sentry_xhr?.url || "";
//   const method = xhr._method || xhr?.__sentry_xhr?.method || "GET";
//   let parsedBody;
//   try {
//     parsedBody = typeof body === "string" && body.startsWith("{")
//       ? JSON.parse(body)
//       : body;
//   } catch {
//     parsedBody = body;
//   }

//   if (url.includes('_gf_pdp')) {
//     return await gcXmlApiRequest(xhr, body);
//   }

//   let rawBody = "";
//   if (typeof parsedBody === "string") {
//     rawBody = parsedBody;
//   } else if (parsedBody instanceof URLSearchParams) {
//     rawBody = parsedBody.toString();
//   } else if (parsedBody instanceof FormData) {
//     rawBody = new URLSearchParams(parsedBody).toString();
//   }
//   const urlLineParams = new URLSearchParams(rawBody);
//   const line = parseInt(urlLineParams.get("line"), 10);
//   const quantity = parseInt(urlLineParams.get("quantity"), 10);
//   const cartEndpoints = [
//     '/cart/add.js', '/cart/change.js', '/cart/update.js',
//     '/cart/add', '/cart/change', '/cart/update'
//   ];
//   const isCartMutation = gcCartApi.some(route => {
//     const base = route.url.replace(".js", "");
//     return (
//       (url.includes(base) || url.includes(base + ".js"))
//     );
//   });

//   let updatApi = [
//     { label: "change", url: "/cart/change.js" },
//     { label: "change", url: "/cart/change" },
//     { label: "update", url: "/cart/update.js" },
//     { label: "update", url: "/cart/update" },
//   ];
//   const isUpdateCartMutation = updatApi.some(route => {
//     const base = route.url.replace(".js", "");
//     return (
//       (url.includes(base) || url.includes(base + ".js"))
//     );
//   });

//   if (isUpdateCartMutation) {
//     let cartDataItem = await gcGetCartData();
//     cartDataItem?.items?.forEach((item, index) => {
//     });

//     let isGiftItem = cartDataItem?.items?.find((cartItem) => String(cartItem?.key) === String(parsedBody?.id));
//     if ((line && cartDataItem?.items[line - 1]) || isGiftItem) {
//       let cartItem = cartDataItem.items[line - 1] || isGiftItem;

//       const params = new URLSearchParams(body);
//       let payLoadData
//       try {
//         payLoadData = JSON.parse(body);
//       } catch (e) {
//         console.error("Failed to parse JSON body:", e);
//       }
//       parsedBody = {};

//       let mylkyMainProData = gc_cartData?.items?.find((cartItem) => String(cartItem?.variant_id) === mylkyMainPro);
//       let mylkyProQuantity = mylkyMainProData?.quantity;

//       if (String(mylkyMainProData?.variant_id) === String(cartItem?.variant_id)) {
//         old_quantity = cartItem?.quantity
//       }

//       if (cartItem.properties && (cartItem.properties._Gf_pdp || cartItem.properties._Gf_Tree_pdp)) {
//         let mylkyMainProData = gc_cartData?.items?.find((cartItem) => String(cartItem?.variant_id) === mylkyMainPro);
//         let mylkyProQuantity = mylkyMainProData?.quantity;
//         let mylkyPlantProData = gc_cartData?.items?.find((cartItem) => cartItem.properties._Gf_Tree_pdp);
//         let mylkyPlantQuantity = mylkyPlantProData?.quantity
//         let mylkyGiftPro = gc_cartData?.items?.filter((cartItem) => (cartItem.properties._Gf_pdp ));
//         let mylkyGiftQuantity = mylkyGiftPro.reduce(
//           (total, item) => total + (item.quantity || 0),
//           0
//         );

//         let mylkyGiftTreePro = gc_cartData?.items?.filter((cartItem) => (cartItem.properties._Gf_pdp && String(cartItem?.variant_id) !== "44038167756870") );
//         let mylkyGiftTreeQuantity = mylkyGiftTreePro.reduce(
//           (total, item) => total + (item.quantity || 0),
//           0
//         );

//         let totalTreeCount = getVariantCount(44038167756870);
//         let totalMylkyGiftQuantity = mylkyGiftTreeQuantity + totalTreeCount;
       
//         if (mylkyGiftPro?.some(gift => gift.variant_id === cartItem?.variant_id)) {
//               let totalMylkyTreeQuantity = totalMylkyGiftQuantity;
//               if(String(cartItem?.variant_id) === "44038167756870"){
//                 if(parseInt(payLoadData.quantity) === 0){
//                     let treeDiff = cartItem?.quantity
//                     removeFromLocalStorage(cartItem?.variant_id, treeDiff)
//                     return await gcXmlApiRequest(xhr, body);
//                 } else {
//                       try {
//                         if (typeof body === "string") {
//                           if (body.includes("quantity=")) {
//                             const params = new URLSearchParams(body);
//                             if (params.has("quantity")) {
//                               params.set("quantity", cartItem?.quantity); 
//                               body = params.toString();
//                             }
//                           }
//                           else if (body.trim().startsWith("{")) {
//                             const temp = JSON.parse(body);
//                             if (temp && temp.quantity !== undefined) {
//                               temp.quantity = cartItem?.quantity; 
//                               body = JSON.stringify(temp);
//                             }
//                           }
//                         }
//                       } catch (err) {
//                         console.error("Failed to adjust quantity:", err);
//                       }
//                       return await gcXmlApiRequest(xhr, body);
//                 }
//               }else{
//                   if (totalMylkyGiftQuantity < mylkyProQuantity) {
//                     let diff_quantity = Math.abs(cartItem.quantity - payLoadData.quantity);
//                     console.log(cartItem?.quantity, "cartItem?.quantity", payLoadData.quantity, "payLoadData.quantity")
//                     if (cartItem?.quantity < payLoadData.quantity) {
//                       addToCart(cartItem?.variant_id)
//                     } else {
//                       removeFromLocalStorage(cartItem?.variant_id, diff_quantity)
//                     }
//                     return await gcXmlApiRequest(xhr, body);
//                   } else {
//                     if (cartItem?.quantity < payLoadData.quantity) {
//                       try {
//                         if (typeof body === "string") {
//                           if (body.includes("quantity=")) {
//                             const params = new URLSearchParams(body);
//                             if (params.has("quantity")) {
//                               params.set("quantity", cartItem?.quantity); 
//                               body = params.toString();
//                             }
//                           }
//                           else if (body.trim().startsWith("{")) {
//                             const temp = JSON.parse(body);
//                             if (temp && temp.quantity !== undefined) {
//                               temp.quantity = cartItem?.quantity; 
//                               body = JSON.stringify(temp);
//                             }
//                           }
//                         }
//                       } catch (err) {
//                         console.error("Failed to adjust quantity:", err);
//                       }
//                       return await gcXmlApiRequest(xhr, body);
//                     } else {
//                       let diff_quantity = Math.abs(cartItem.quantity - payLoadData.quantity);
//                       removeFromLocalStorage(cartItem?.variant_id, diff_quantity)
//                       return await gcXmlApiRequest(xhr, body);
//                     }
//                   }
//               }
//             }
//           }
//           // if (cartItem?.quantity < payLoadData.quantity) {
//           //   if (typeof parsedBody === "object") {
//           //     parsedBody.quantity = cartItem?.quantity;
//           //   } else if (parsedBody instanceof URLSearchParams) {
//           //     parsedBody.set("quantity", cartItem?.quantity);
//           //   }
//           //   const newParams = new URLSearchParams(parsedBody).toString();
//           //   return await gcXmlApiRequest(xhr, newParams);
//           // } else {
//           //   let diff_quantity = Math.abs(cartItem.quantity - payLoadData.quantity);
//           //   removeFromLocalStorage(cartItem?.variant_id, diff_quantity)
//           //   return await gcXmlApiRequest(xhr, body);
//           // }
//         }
//   }
//   await gcXmlApiRequest(xhr, body);
//   if (isCartMutation) {
//     setTimeout(() => {
//       document.dispatchEvent(new CustomEvent('cart:changed'));
//     }, 700);
//   }
// };

// async function gcXmlApiRequest(xhr, params) {
//   const intervals = 10;
//   const maxTries = 50;
//   let tries = 0;
//   while (xhr.readyState !== XMLHttpRequest.OPENED && tries < maxTries) {
//     await new Promise(res => setTimeout(res, intervals));
//     tries++;
//   }
//   if (xhr.readyState === XMLHttpRequest.OPENED) {
//     try {
//       gc_originalSend.call(xhr, params);
//     } catch (err) {
//       console.error("Failed during send:-", err);
//     }
//   } else {
//     console.warn("xhr not open after waiting, skipping send");
//   }
// }

// green friday end--------------------------------------------------------------------------------------------------------------------------




var mylkyMainPro = "42571798609990";
var mylkyGiftPro = "44449800618054";
let gc_cartData;
let isRemovingGift = false;
const originalXhrSend = XMLHttpRequest.prototype.send;
let mainProQuantity;

async function gcGetCartData() {
  const res = await fetch("/cart.json", {
    headers: { "x-bypass-intercept": "1" },
  });
  gc_cartData = await res.json();
  return gc_cartData;
}

const gcCartApi = [
  { label: "add", url: "/cart/add.js" },
  { label: "add", url: "/cart/add" },
  { label: "change", url: "/cart/change.js" },
  { label: "change", url: "/cart/change" },
  { label: "update", url: "/cart/update.js" },
  { label: "update", url: "/cart/update" },
  { label: "clear", url: "/cart/clear.js" },
  { label: "clear", url: "/cart/clear" },
];

const removeMylkyGift = async () => {
  if (!gc_cartData?.items?.length) return;
  const updates = {};
  const giftProduct = gc_cartData?.items?.filter(
    (item) =>
      String(item?.variant_id) === mylkyGiftPro &&
      item?.properties?._Gf_pdp
  );
  if (!giftProduct.length) return;

  giftProduct.forEach((cartItem) => {
    updates[cartItem?.key] = 0;
  });

  const response = await fetch("/cart/update.js?_gf_pdp", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({ updates }),
  });

  const result = await response.json();

  if (!response.ok) {
    console.error("🚫 Error:", result);
    throw new Error(`Cart update failed: ${response.status}`);
  }
};

const updateMylkyGift = async () => {
  if (!gc_cartData?.items?.length) return;
  const updates = {};
  const giftProduct = gc_cartData?.items?.filter(
    (item) =>
      String(item?.variant_id) === mylkyGiftPro &&
      item?.properties?._Gf_pdp
  );
  if (!giftProduct.length) return;

  giftProduct.forEach((cartItem) => {
    updates[cartItem?.key] = mainProQuantity;
  });

  const response = await fetch("/cart/update.js?_gf_pdp", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({ updates }),
  });

  const result = await response.json();
  await gcGetCartData();
  if (!response.ok) {
    console.error("🚫 Error:", result);
    throw new Error(`Cart update failed: ${response.status}`);
  }
};

document.addEventListener("cart:changed", async () => {
      if (isRemovingGift) return;
      isRemovingGift = true;
      await gcGetCartData();
      if(!mainProQuantity || mainProQuantity === 0){
          await removeMylkyGift();
      }else{
         await updateMylkyGift();
  }
 
  isRemovingGift = false;
});

function getVariantId(value) {
  return typeof value === "string" ? value.split(":")[0] : value;
}

XMLHttpRequest.prototype.send = async function (body) {
  const xhr = this;
  const url = xhr._url || xhr?.__sentry_xhr?.url || "";
  const method = xhr._method || xhr?.__sentry_xhr?.method || "GET";

  let parsedBody;
  try {
    parsedBody =
      typeof body === "string" && body.startsWith("{")
        ? JSON.parse(body)
        : body;
  } catch {
    parsedBody = body;
  }

  if (url.includes("_gf_pdp")) {
    return originalXhrSend.call(xhr, body);
  }
  const quantity = parsedBody?.quantity;
  let variantId = parsedBody?.id;
  variantId = getVariantId(variantId);
  const updatApi = [
    { label: "change", url: "/cart/change.js" },
    { label: "change", url: "/cart/change" },
    { label: "update", url: "/cart/update.js" },
    { label: "update", url: "/cart/update" },
  ];

  const isUpdateCartMutation = updatApi.some((route) => {
    const base = route.url.replace(".js", "");
    return url.includes(base) || url.includes(base + ".js");
  });

  if (isUpdateCartMutation && variantId) {
    await gcGetCartData();
     const giftProduct = gc_cartData?.items?.filter(
    (item) =>
      String(item?.variant_id) === mylkyGiftPro &&
      item?.properties?._Gf_pdp
  );
    const mainProduct = gc_cartData?.items?.filter(
    (item) =>
      String(item?.variant_id) === mylkyMainPro 
  );

        if (
          String(variantId) === String(mylkyGiftPro) &&
         (quantity > giftProduct?.[0]?.quantity)
        ) {
         let parsedBody = {};
         if (typeof parsedBody === "object") {
              parsedBody.quantity = giftProduct?.[0]?.quantity;
            } else if (parsedBody instanceof URLSearchParams) {
              parsedBody.set("quantity", giftProduct?.[0]?.quantity);
            }
            const newParams = new URLSearchParams(parsedBody).toString();
              return originalXhrSend.call(xhr, newParams);
        }  else if (
          String(variantId) === String(mylkyMainPro) &&
          quantity === 0
        ) {
          mainProQuantity = 0
            document.dispatchEvent(new CustomEvent("cart:changed"));
        } else if(quantity < mainProduct?.[0]?.quantity){
            mainProQuantity=quantity;
            document.dispatchEvent(new CustomEvent("cart:changed"));
        }
  }
  return originalXhrSend.call(xhr, body);
};

function gcXmlApiRequest(xhr, params) {
  try {
    originalXhrSend.call(xhr, params);
  } catch (err) {
    console.error("Failed during send:", err);
  }
}